import { IAgentDetails, IAgentV2 } from "@/core/interfaces/agent.interface";
import { IEntityEmployee } from "../types";

type OrganizationUserItem = IAgentV2 | IAgentDetails;

const toAgentV2 = (user: OrganizationUserItem): IAgentV2 =>
  "organization_user" in user ? user.organization_user : user;

export const mapOrganizationUsersToEmployees = (
  users: OrganizationUserItem[],
): IEntityEmployee[] =>
  users.map((user) => {
    const agent = toAgentV2(user);
    return {
      user_id: agent.organization_user_id,
      full_name: agent.user.full_name,
      email: agent.user.email,
    };
  });
